module.exports = __webpack_public_path__ + "media/recipes/16-55d8dd64.png";